export const UPDATE = "UPDATE"
export const ALARM = "ALARM"
export const UPDATE_MONEY = "UPDATE_MONEY"
export const INITIAL_STATE = "INITIAL_STATE"
export const UNREAD_MESSAGES = "UNREAD_MESSAGES"

